var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"status-chip",attrs:{"dense":"","small":!_vm.xSmall,"x-small":_vm.xSmall,"label":"","color":_vm.task.task_status_colour}},[_vm._v(_vm._s(_vm.task.task_status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }